module.exports = __webpack_public_path__ + "images/territory_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/territory_2.png
// module id = 56
// module chunks = 0